export const MENU_ITEM_PARAMETERS = {
    IS_TAKEAWAY: 'IS_TAKEAWAY',
    IS_DELIVERY: 'IS_DELIVERY',
    IS_STAFF_OWN: 'IS_STAFF_OWN',
    IS_STAFF_OTHER: 'IS_STAFF_OTHER',
    IS_DISCOUNT: 'IS_DISCOUNT',
    IS_NOPRINT: 'IS_NOPRINT',
    IS_PREORDER: 'IS_PREORDER',
}
